
<template>
    
        <mars-view class="order-card c-order-container" :class="{'card-active': cardActive}" @touchstart.native="toggleActive(true)" @touchend.native="toggleActive(false)" @click.native="tapFn(data)"><mars-view class="l-span c-gap-bottom-small container-type"><mars-view class="l-span l-flex-fill"><mars-text class="c-color-black c-gap-right-small">
                {{ data.product_name }}
            </mars-text><mars-text style="#ff6f61">
                ¥{{ data.order_price }}
            </mars-text></mars-view><mars-view class="l-color-theme c-font-normal">
            {{ data.order_status }}
        </mars-view></mars-view><mars-view class="c-line-clamp1 c-font-normal c-color-normal order-time">
        提交时间：{{ data.order_time }}
    </mars-view><mars-view v-if="data.trade_oid" class="c-line-clamp1 c-font-normal c-color-normal order-time">
        订单编号：{{ data.trade_oid }}
    </mars-view><mars-view class="c-line-clamp1 c-font-normal c-color-normal order-time"><mars-text>合作服务方：{{ data.resource_name }}</mars-text><mars-text class="phone-text" @click.native="tapFn({target: data.lawyer_phone,type: 'call'})">{{ data.lawyer_phone }}</mars-text></mars-view><mars-view class="c-line-clamp1 c-font-normal c-color-normal order-resource-card"><mars-image class="order-resource-card-image" :src="data.resource_logo"></mars-image><mars-view class="order-resource-card-text"><mars-view>瀛和律师机构</mars-view><mars-view>为你提供专业法律服务</mars-view></mars-view></mars-view><mars-view v-if="data.btns" class="l-span-right c-gap-top order-btn"><mars-view v-for="(btn, i) in data.btns" :key="i" class="order-card-btn"><mars-view :class="{'button-defaule-can': btn.colored === '1'}" class="button-defaule" @click.native.stop="tapFn(btn)">
                {{ btn.txt }}
            </mars-view></mars-view></mars-view><show-modal v-if="showAfterModal" :modal-data="modalData" @onCancle="cancleModal" @onConfirm="confirmModal"></show-modal></mars-view>
    
</template>

<script>
// import Button from '@baidu/mars-ui/components/Button/Button';
import { act } from '../../static/utils/navigate';
import { request } from '../../static/utils/request.js';
import showModal from "../../pages/order/components/show-modal.vue";
export default {
  components: {
    'show-modal': showModal
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    consultIndex: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      cardActive: false,
      showAfterModal: false,
      modalData: null
    };
  },
  methods: {
    tapFn({
      target,
      txt,
      type,
      content
    }) {
      switch (type) {
        case 'del':
          this.$api.showModal({
            title: '温馨提示',
            content: '删除后将无法恢复，同时无法查看律师回复',
            confirmText: '确认删除',
            confirmColor: this.themeColor,
            success: obj => {
              if (obj.confirm) {
                request({
                  url: target
                }).then(() => {
                  // this.$api.showModal({
                  //     title: '删除成功'
                  // });
                });
                this.$emit('del');
              }
            }
          });
          break;
        case 'model':
          this.showAfterModal = true;
          this.modalData = content;
          break;
        default:
          act({
            target,
            type
          });
      }
    },
    toggleActive() {
      // 点击态todo
      // this.cardActive = state;
    },
    cancleModal() {
      this.showAfterModal = false;
    },
    confirmModal(value) {
      act(value.confirm);
    }
  }
};
</script>

<style scoped>
.c-order-container {
  padding: 17px 14px;
  background: #fff;
  margin-bottom: 8px;
}
.order-card {
  transition: background-color 0.1s cubic-bezier(0.18, 0, 0.26, 1);
}
.order-card-reply {
  box-shadow: 0 0 7px 0 rgba(0, 56, 68, 0.08);
  border-radius: 8px;
}
.order-card-reply-img {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  margin-right: 8px;
}
.order-card .container-type {
  font-size: 16px;
  line-height: 16px;
  margin-bottom: 10px;
}
.order-card .order-btn {
  margin-top: 15px;
  margin-bottom: 3px;
}
.order-card-expert-img {
  width: 42px;
  height: 42px;
  border-radius: 50%;
}
.order-card-btn {
  margin-left: 8px;
}
.order-card .phone-text {
  color: #445fbb;
  margin-left: 10px;
}
.card-active {
  background-color: rgba(0, 0, 0, 0.04);
}
.trick-width {
  width: calc(100% - 50px);
}
.button-defaule {
  height: 30px;
  width: 89px;
  line-height: 28px;
  text-align: center;
  background: #fff;
  border: 1px solid #cbcbcb;
  border-radius: 19px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #333;
  box-sizing: border-box;
}
.button-defaule-can {
  color: #445fbb;
  border-color: #445fbb;
}
.order-resource-card {
  height: 72px;
  background: #fff;
  box-shadow: 0px 0px 20px 0px rgba(0, 56, 68, 0.08);
  border-radius: 8px;
  display: flex;
  padding: 15px 17px;
  box-sizing: border-box;
  margin-top: 19px;
}
.order-resource-card-image {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  flex-shrink: 0;
  flex-grow: 0;
  margin-right: 8px;
}
.order-resource-card-text {
  flex: 0;
  font-size: 14px;
  color: #999;
  line-height: 14px;
  font-weight: 400;
  display: flex;
  padding: 2px 0;
  flex-direction: column;
  justify-content: space-between;
}

</style>
